import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-white text-neutral-900">
      <header className="border-b border-neutral-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="privacy-back">
            <div className="w-10 h-10 flex items-center justify-center bg-[#C5A059] text-white font-heading font-semibold">FT</div>
            <div>
              <p className="font-heading text-sm font-medium leading-tight">Fix Technical Renovation Company</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">Premier Interior Fitting · Dubai</p>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-[#C5A059]">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">Legal</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-light tracking-tight mb-8">Privacy Policy</h1>

        <div className="text-neutral-700 leading-relaxed space-y-6 text-base">
          <p>
            Fix Technical Renovation Company (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) respects your privacy. This Privacy Policy explains how we collect, use, and safeguard information you provide when requesting a free site inspection, renovation quote, or related services.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Information we collect</h2>
          <p>
            We collect information you submit through our lead forms, including your name, phone number, project type, location, and message. We may also collect basic analytics about how visitors use our website.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">How we use it</h2>
          <p>
            We use your information solely to contact you about your renovation enquiry, schedule a free site inspection, share quotations, and provide updates about your renovation project. We do not sell your information.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Data retention</h2>
          <p>
            We retain enquiry information for as long as necessary to respond to your request and comply with applicable Dubai laws.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Contact</h2>
          <p>
            For privacy questions, contact us at{" "}
            <a href={`mailto:${COMPANY.email}`} className="text-[#C5A059] underline">{COMPANY.email}</a>{" "}
            or call {COMPANY.phone} / WhatsApp {COMPANY.whatsapp}. Office: {COMPANY.address}.
          </p>
        </div>
      </main>
    </div>
  );
}
